import { render, staticRenderFns } from "./Detail-Users.vue?vue&type=template&id=321f1d2d&"
import script from "./Detail-Users.vue?vue&type=script&lang=js&"
export * from "./Detail-Users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports